/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Pattern_Enabled_UnnamedInputs */



/**
* | output |
* | --- |
* | "This pattern is now active and monitoring requests" |
*
* @param {Audit_Details_Pattern_Enabled_UnnamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_pattern_enabled_unnamed = /** @type {((inputs?: Audit_Details_Pattern_Enabled_UnnamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Pattern_Enabled_UnnamedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Muster ist jetzt aktiv und überwacht Anfragen")
	return /** @type {LocalizedString} */ ("This pattern is now active and monitoring requests")
});